import * as React from 'react';

const ArrowRightIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.583 8.251a.67.67 0 0 0-.195-.471l-4-4a.667.667 0 1 0-.943.943L8.974 8.25 5.445 11.78a.667.667 0 1 0 .943.943l4-4a.67.67 0 0 0 .195-.472"
    ></path>
  </svg>
);

export default ArrowRightIcon;
